import { action } from "../common/Action"
import { RefrigerantiClient } from "../generated";
const Client = new RefrigerantiClient();
class RefrigerantiActions {

    @action
    async getAll() {
        return (await Client.getAll())!;
    };
}
export default new RefrigerantiActions();